import React from "react";
import { IconRules } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const radiusTokens = [
  { token: "--ds-radius-xs", value: "4px", usage: "keine Regel." },
  { token: "--ds-radius-sm", value: "8px", usage: "Inputs, Selects und kompakte innere Elemente." },
  { token: "--ds-radius-md", value: "12px", usage: "Standard für Cards, Tables und grössere Container." },
  { token: "--ds-radius-lg", value: "16px", usage: "keine Regel." },
  { token: "--ds-radius-xl", value: "20px", usage: "Dialoge und dominante Overlay-Surfaces." },
  { token: "--ds-radius-pill", value: "999px", usage: "Chips, Switches, Radio, Progress und runde Elemente." },
];

function RadiusToken({ item }) {
  return (
    <div className="ds-docs-radius-token">
      <div className="ds-docs-radius-token__preview" style={{ borderRadius: `var(${item.token})` }} aria-hidden="true" />
      <div className="ds-docs-radius-token__content">
        <div className="ds-docs-radius-token__meta">
          <code>{item.token}</code>
          <span>{item.value}</span>
        </div>
        <div className="ds-docs-radius-token__usage">{item.usage}</div>
      </div>
    </div>
  );
}

export default function RadiusDocs() {
  return (
    <DocsSectionCard title="Radius">
      <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--radius">
        <DocsPreviewPanel label="Tokens" icon={IconRules}>
          <div className="ds-docs-preview-surface ds-docs-radius-sheet">
            {radiusTokens.map((item) => (
              <RadiusToken key={item.token} item={item} />
            ))}
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow
          intro="Wichtigste Regeln:"
          items={[
            "Als Default für alle grösseren Container wie Cards, Listen-Container und Tables radius-md (12 px) verwenden.",
          ]}
        />
      </div>
    </DocsSectionCard>
  );
}
